import {
    getSessionUtmParameterName,
    getVisitorUtmParameterName,
    isInPlaceUrlAttributionEnabled,
} from '../../config/SiteConfigManager';

interface CurrentPageRoseAttribution {
    domain: string;
    visitorId?: string | null;
    lastActiveSessionId?: string | null;
}

export function updateCurrentPageRoseAttribution({
    domain,
    visitorId,
    lastActiveSessionId,
}: CurrentPageRoseAttribution): boolean {
    if (typeof window === 'undefined') return false;
    if (!isInPlaceUrlAttributionEnabled(domain)) return false;

    const visitorParamName = getVisitorUtmParameterName(domain);
    const sessionParamName = getSessionUtmParameterName(domain);
    const hasVisitorAttribution = Boolean(visitorParamName && visitorId);
    const hasSessionAttribution = Boolean(sessionParamName && lastActiveSessionId);

    if (!hasVisitorAttribution && !hasSessionAttribution) return false;

    try {
        const url = new URL(window.location.href);
        let changed = false;

        if (visitorParamName && visitorId && url.searchParams.get(visitorParamName) !== visitorId) {
            url.searchParams.set(visitorParamName, visitorId);
            changed = true;
        }

        if (
            sessionParamName &&
            lastActiveSessionId &&
            url.searchParams.get(sessionParamName) !== lastActiveSessionId
        ) {
            url.searchParams.set(sessionParamName, lastActiveSessionId);
            changed = true;
        }

        if (!changed) return false;

        window.history.replaceState(window.history.state, '', url.toString());
        return true;
    } catch {
        return false;
    }
}
